import Vue from 'vue'

/* ------------------ Config --------------------------- */
Vue.config.productionTip = false

/* ------------------ variable --------------------------- */

import geturlpara from './js/weixinLogin.js';
Vue.prototype.$geturlpara = geturlpara;

import axios from "axios";
Vue.prototype.$axios = axios;

import {
  fetch,
  post,
  postUrl,
  postImg
} from "./js/http.js";
Vue.prototype.$fetch = fetch;
Vue.prototype.$post = post;
Vue.prototype.$postUrl = postUrl;
Vue.prototype.$postImg = postImg;
Vue.prototype.baseURL = process.env.API_BASE_URL;
// Vue.prototype.baseURL = "http://api.t.enterprise.gongyi.la";

import Validators from './js/validators'
for (let key in Validators) {
  Vue.prototype[key] = Validators[key]
}

import {
  delay
} from './js/util'
Vue.prototype.$delay = delay

import Account from './js/account'
Vue.prototype.$account = Account

import Filter from './js/filter'
for (let key in Filter) {
  Vue.filter(key, Filter[key])
}

import Document from './js/document'
for (let key in Document) {
  Vue.prototype[key] = Document[key]
}

import EventBus from './js/eventBus'
Vue.prototype.$eventBus = EventBus

/* ------------------ Components --------------------------- */

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import YDUI from 'vue-ydui'
import 'vue-ydui/dist/ydui.rem.css'
Vue.use(YDUI)

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)

import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import moment from 'moment'
Vue.use(moment)



// WEBPACK FOOTER //
// ./src/global.js